export const isUserLoggedIn = state => state.auth.isUserLoggedIn;



// WEBPACK FOOTER //
// ./src/store/selectors/auth.js